import { useSelector } from 'react-redux';
import { useItemTags } from '../hooks/useItemTags';
import lock from '../img/icons/lock.svg';
import { getContrastingTextColor } from '../helpers/colourUtils';
import { useMemo } from 'react';

const getLoyaltyTagText = (tag, itemId, loyaltyScheme) => {
    if (!tag || !itemId || loyaltyScheme === undefined || loyaltyScheme === null) return '';
    const isPicollo = itemId === '10000007311';
    const isRomana = itemId === '27';
    const lowerCaseTag = typeof tag === 'string' ? tag.toLowerCase() : '';

    switch (loyaltyScheme) {
        case 2:
            switch (lowerCaseTag) {
                case 'bronze':
                    if (isPicollo) return '- 25% off';
                    return 'Reward';
                case 'silver':
                    if (isPicollo) return '- 50% off';
                    if (isRomana) return 'Reward - Free Romana Upgrade';
                    return 'Reward';
                case 'gold':
                    if (isPicollo) return '- Free';
                    if (isRomana) return 'Reward - Free Romana Upgrade';
                    return 'Reward';
                default:
                    return 'Reward';
            }
        default:
            switch (lowerCaseTag) {
                case 'gold':
                    if (isRomana) return 'Reward - Free Romana Upgrade';
                    return 'Reward';
                default:
                    return 'Reward';
            }
    }
}

export const Tags = ({ item, isBundle = false, currentTier, loyaltySchemeVersion, showLocked, excludeChildTags, showLowerBirthdayTiers = false, wrapperClass, outOfStockOverride = false, outOfStockDisabled = false }) => {
    const { loyaltyTags = [], birthdayTags = [], uiTags = [], lockedBDayTags = [], lockedLoyaltyTags = [], hasTags } = useItemTags(item, isBundle, currentTier, loyaltySchemeVersion, showLocked, excludeChildTags, showLowerBirthdayTiers);
    const loyaltyScheme = useSelector(state => state.loyalty?.customer?.loyaltySchemeVersion);
    if (!hasTags && !item?.outOfStock && !outOfStockOverride) return null;
    if (!item) return null;
    return (<div className={wrapperClass || ''}>
        {(item?.outOfStock || outOfStockOverride) && !outOfStockDisabled ?
            <div className='ui-tag outofstock'>
                Out of stock
            </div>
            : null
        }
        {Array.isArray(birthdayTags) && birthdayTags?.length > 0 &&
            birthdayTags.map(tag => (
                <div key={`birthdayTag-${tag}`} data-testid={`tag-birthday-${tag}`} className={`tag ui-tag ${typeof tag === 'string' ? tag.toLowerCase() : ''}`}>Birthday{' '}Treat</div>
            ))}
        {Array.isArray(loyaltyTags) && loyaltyTags?.length > 0 &&
            loyaltyTags.map(tag => (
                <div key={`loyaltyTag-${tag}`} data-testid={`tag-tier-reward-tag-${tag}`} className={`tag ui-tag ${typeof tag === 'string' ? tag.toLowerCase() : ''}`}>{tag}{' '}
                    {tag && item?.id && loyaltyScheme !== undefined
                        ? getLoyaltyTagText(tag, item.id, loyaltyScheme)
                        : ''}</div>
            ))}
        {Array.isArray(lockedBDayTags) && lockedBDayTags?.length > 0 &&
            lockedBDayTags.map(tag => (
                <div key={`lockedBDayTag-${tag}`} data-testid={`tag-birthday-${tag}-locked`} className={`tag ui-tag ${typeof tag === 'string' ? tag.toLowerCase() : ''} locked`}> Birthday Treat <img alt="locked" src={lock} className="icon is-small" style={{ width: 24 }} /> </div>
            ))}
        {Array.isArray(lockedLoyaltyTags) && lockedLoyaltyTags?.length > 0 &&
            lockedLoyaltyTags.map(tag => (
                <div key={`lockedLoyaltyTag-${tag}`} data-testid={`tag-tier-reward-tag-${tag}-locked`} className={`tag ui-tag ${typeof tag === 'string' ? tag.toLowerCase() : ''} locked`}>{tag}{' '}
                    {tag && item?.id && loyaltyScheme !== undefined
                        ? getLoyaltyTagText(tag, item.id, loyaltyScheme)
                        : ''} <img alt="locked" src={lock} className="icon is-small" style={{ width: 24 }} /> </div>
            ))}
        {!isBundle && Array.isArray(uiTags) && uiTags?.length > 0 &&
            uiTags.map(tag => (
                <div key={`uiTag-${tag}`} data-testid={`tag-ui-${tag}`} className={`tag ui-tag new`}>{typeof tag === 'string' && tag.startsWith('#') ? tag.slice(1) : tag}</div>
            ))}
        {isBundle && Array.isArray(uiTags) && uiTags?.length > 0 &&
            uiTags.map(tag => {
                if (typeof tag !== 'object' || !tag.name || !tag.colour) return null
                const textColor = getContrastingTextColor(tag.colour);
                return (
                    <div
                        key={`uiTag-${tag.name}`}
                        data-testid={`tag-ui-${tag.name}`}
                        style={{
                            backgroundColor: tag.colour,
                            color: textColor,
                        }}
                        className="tag ui-tag"
                    >
                        {tag.name}
                    </div>
                );
            })}
    </div>);
}